// dependent components from the material design module
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';

// core for authentication, services and guards
import { AuthenticationRoutes } from './authentication.routing';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthenticationLoginComponent } from './components/login/login.component';
import { AuthenticationLogoutComponent } from './components/logout/logout.component';
import { AuthenticationTokenComponent } from './components/token/token.component';
import { AuthenticationExchangeComponent } from './components/exchange/exchange.component';
import { AuthenticationErrorComponent } from './components/error/authentication-error.component';
import { SnagLayoutModule } from '@libs/layout';
import { ControlBarModule } from '@libs/components/control-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // material design components
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    SnagLayoutModule,
    ControlBarModule,
    // routing
    RouterModule.forChild(AuthenticationRoutes),
  ],
  exports: [AuthenticationErrorComponent],
  declarations: [
    AuthenticationLoginComponent,
    AuthenticationLogoutComponent,
    AuthenticationTokenComponent,
    AuthenticationExchangeComponent,
    AuthenticationErrorComponent,
  ],
  // this will provide everything for the app, should only be called from the app's main module
  // once and it will then be assumed available for all other modules within it.  this way only one instance
  // of auth is ever provided via DI to any of the modules within this app
  providers: [],
})
export class SnagAuthenticationModule {}

// components
export { AuthenticationErrorComponent } from './components/error/authentication-error.component';

// guards
export { AuthenticationGuard } from './guards/authentication.guard';
export { ClaimGuard } from './guards/claim.guard';
export { DefaultPageGuard } from './guards/default-page.guard';
export { SelfSignupSettingGuard } from './guards/selfsignup-setting.guard';
